import { configInputConverter } from '@seu-converter';
import {
  SeuApiConverter,
  SeuOperatingCondition,
  SeuOperatingConditionApi,
  SeuOperatingConditionBase,
  SeuOperatingConditionBaseApi,
} from '@seu-types';

export const operatingConditionConverter: SeuApiConverter<
  SeuOperatingCondition,
  SeuOperatingConditionApi
> = {
  fromApi: (input) => {
    const base = operatingConditionBaseConverter.fromApi(input);

    return {
      id: String(input.id),
      title: base.title,
      description: base.description,
      categories: base.categories,
      inputStreams: base.inputStreams,
      active: base.active,
    };
  },
  toApi: (input) => {
    const base = operatingConditionBaseConverter.toApi(input);

    return {
      id: Number(input.id),
      title: base.title,
      description: base.description,
      categories: base.categories,
      inputStreams: base.inputStreams,
      active: base.active,
    };
  },
};

export const operatingConditionBaseConverter: SeuApiConverter<
  SeuOperatingConditionBase,
  SeuOperatingConditionBaseApi
> = {
  fromApi: (input) => {
    return {
      ...input,
      inputStreams: input.inputStreams.map((inputStream) => {
        return {
          inputs: inputStream.inputs.map((configInput) => {
            return configInputConverter.fromApi(configInput);
          }),
        };
      }),
    };
  },
  toApi: (input) => {
    return {
      ...input,
      categories: input.categories ?? [],
      inputStreams: input.inputStreams.map((inputStream) => {
        return {
          inputs: inputStream.inputs.map((configInput) => {
            return configInputConverter.toApi(configInput);
          }),
        };
      }),
    };
  },
};
